import moment from 'moment-timezone'

export const COMPLEX_FILTER_DATE_FORMAT = 'YYYY-MM-DD'

export function getComplexDateFilterFormattedDate(value: string | moment.Moment): string | undefined {
  const momentDate = moment.isMoment(value) ? value : moment(value, COMPLEX_FILTER_DATE_FORMAT)
  return momentDate.isValid() ? momentDate.format(COMPLEX_FILTER_DATE_FORMAT) : undefined
}
